export default __webpack_public_path__ + "static/media/Social Links.78193a2e.svg";